// Shared positioning/animation helpers for Base UI popups (Tooltip, Popover, Dropdown).

/** Placement names (top, topLeft, …), shared by Tooltip, Popover and Dropdown. */
export type Placement =
  | "top"
  | "topLeft"
  | "topRight"
  | "bottom"
  | "bottomLeft"
  | "bottomRight"
  | "left"
  | "leftTop"
  | "leftBottom"
  | "right"
  | "rightTop"
  | "rightBottom";

/** antd placement → Base UI positioner `side` + `align`. */
export const toPositioning = (placement: Placement) => {
  const [, side = "top", suffix] = /^(top|bottom|left|right)(Left|Right|Top|Bottom)?$/.exec(placement) ?? [];
  const align = suffix === "Left" || suffix === "Top" ? "start" : suffix ? "end" : "center";

  return { side: side as "top" | "bottom" | "left" | "right", align: align as "start" | "center" | "end" };
};

/** Popup z-index: above Dialog (z-1000), so tooltips, selects and menus opened from inside a dialog stay visible. */
export const POPUP_Z_INDEX = "z-[1100]";

/** Shared enter/exit animation for Base UI popups (reads the `data-starting/ending-style` attributes). */
export const POPUP_TRANSITION =
  "origin-[var(--transform-origin)] transition-[transform,scale,opacity] duration-150 data-[ending-style]:scale-95 data-[ending-style]:opacity-0 data-[starting-style]:scale-95 data-[starting-style]:opacity-0";
